import styled from 'styled-components/macro';

import caretSrc from './assets/caret.svg';

const MainHeader = styled.header`
  display: flex;
  gap: 4px;

  height: 150px;
  padding: 4px;

  border-radius: 4px;
  background: radial-gradient(#3785f6, #1764dc);
`;

// const MainHeaderControls = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 16px;

//   padding: 40px;
//   margin-left: auto;

//   button {
//     height: 63px;
//   }
// `;

const MainHeaderStat = styled.div<{ highlight?: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 12px;

  padding: 0 50px;

  position: relative;

  border-radius: 2px;
  background-color: ${props => (props.highlight ? '#3a87eb' : 'transparent')};

  color: #fff;

  &:nth-child(2) {
    border-radius: 0;

    /* &:after {
      content: '';
      display: block;
      width: 1px;
      height: calc(100% - 50px);

      position: absolute;
      right: -50px;
      top: 25px;

      background-color: #488df4;
    } */
  }
`;

const StatLabel = styled.span`
  color: #a2c2ef;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
`;

const StatValue = styled.div`
  display: flex;
  gap: 8px;

  font-family: Bebas Neue, sans-serif;
  font-weight: 600;
`;

const StatValueMain = styled.strong`
  font-size: 32px;
`;

const StatValueChange = styled.div`
  display: flex;
  align-items: center;

  font-size: 16px;

  > i {
    margin-left: 6px;

    font-style: normal;
    color: #92b9f2;
  }
`;

// const Button = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   height: 60px;
//   padding: 20px 32px;

//   border-radius: 6px;
//   border: none;
//   box-shadow: 0 20px 36px 0 rgba(0, 0, 0, 0.1);
//   background-color: #fbfbfd;

//   font-size: 16px;
//   font-weight: 500;
//   color: ${props => props.theme.text0};
// `;

// const SecondaryButton = styled(Button)`
//   background-color: #4683e2;
// `;

// const SecondaryButtonIcon = styled.div`
//   width: 4px;
//   height: 4px;

//   position: relative;

//   background-color: #fff;
//   border-radius: 50%;

//   &::before,
//   &::after {
//     content: '';
//     display: block;

//     width: 4px;
//     height: 4px;

//     position: absolute;
//     top: -6px;

//     background-color: #fff;
//     border-radius: 50%;
//   }

//   &::after {
//     top: 6px;
//   }
// `;

export default function WalletHeader() {
  return (
    <MainHeader>
      <MainHeaderStat highlight>
        <StatLabel>total balance</StatLabel>
        <StatValue>
          <StatValueMain>$42,554.31</StatValueMain>
          <StatValueChange>
            <img src={caretSrc} alt="" />
            13.4% <i>$2,192</i>
          </StatValueChange>
        </StatValue>
      </MainHeaderStat>
      <MainHeaderStat>
        <StatLabel>Available</StatLabel>
        <StatValue>
          <StatValueMain>$7,554.31</StatValueMain>
          <StatValueChange>
            <img src={caretSrc} alt="" />
            $492
          </StatValueChange>
        </StatValue>
      </MainHeaderStat>
      <MainHeaderStat>
        <StatLabel>Unstaking</StatLabel>
        <StatValue>
          <StatValueMain>$7,554.31</StatValueMain>
          <StatValueChange>
            <img src={caretSrc} alt="" />
            $492
          </StatValueChange>
        </StatValue>
      </MainHeaderStat>
      {/*<MainHeaderControls>
        <Button type="button">Delegate</Button>
        <SecondaryButton type="button">
          <SecondaryButtonIcon />
        </SecondaryButton>
      </MainHeaderControls>*/}
    </MainHeader>
  );
}
